export const Formats = [
  { title: "MP4" },
  { title: "MP4 watermark" },
  { title: "MP3" },
];
